import {GeneralDataInterface} from "../interfaces/GeneralDataInterface";

export const generalFields = (generalData: GeneralDataInterface, setGeneralData) => [
    // {
    //     name: 'referentie',
    //     label: 'Referentie',
    //     type: 'text',
    //     value: generalData.apiReference,
    //     disabled: true,
    //     required: true,
    //     onChange: (data: HTMLInputElement) => setGeneralData({...generalData, reference: data.value})
    // },
    {
        name: 'requestDate',
        label: 'Aanvraagdatum',
        type: 'text',
        value: generalData.requestDate,
        disabled: true,
        required: true,
        onChange: (data: HTMLInputElement) => setGeneralData({...generalData, requestDate: data.value})
    }
]